import {SearchOutlined} from '@ant-design/icons';
import React, {useRef} from 'react';
import DebouncingCurrencyInput from '../../elements/DebouncingCurrencyInput';
import {useSelector} from "react-redux";


const PriceFilterTable = () => {
    // const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const filter = useSelector((state) => state.TableRedux.filter);


    const getColumnPriceProps = (initialValue1 = '', callbackNumber1, placeholder1 = 'مبلغ از',dataIndex) => ({
        filterDropdown: (/*{setSelectedKeys, selectedKeys, confirm,  clearFilters}*/) => (
            <div className='d-flex flex-column gap-2'
                 style={{
                     padding: 8,
                     width: '180px'
                 }}
            >

                <DebouncingCurrencyInput defaultValue={initialValue1}
                                         onChange={(value) => {
                                             callbackNumber1(value)
                                         }}
                                         placeholder={placeholder1}/>

                {/*<DebouncingCurrencyInput defaultValue={initialValue2}*/}
                {/*    onChange={(value) => {*/}
                {/*        callbackNumber2(value)*/}
                {/*    }}*/}
                {/*    placeholder={placeholder2}/>*/}


            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filter[dataIndex] ? 'blue'  : undefined,
                }}
            />
        ),

        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },

    });


    return [getColumnPriceProps];
};

export default PriceFilterTable;